import { render } from "./Chapter.vue?vue&type=template&id=4434c9f4"
import script from "./Chapter.vue?vue&type=script&lang=js"
export * from "./Chapter.vue?vue&type=script&lang=js"

import "./Chapter.vue?vue&type=style&index=0&id=4434c9f4&lang=css"
script.render = render

export default script